
      import Share from './share.vue'
      import type { App, Plugin } from 'vue'

      export const SharePlugin: Plugin = {
        install(app: App) {
          app.component('Share', Share)
        },
      }
      export { Share }
      